import React from "react";
import { useTranslation } from "react-i18next";

import styled from "styled-components/macro";

const Container = styled.div`
  background: ${({ theme }) => theme["@primary"]};
  flex-grow: 1;
  padding: 12px 12px 0 12px;
  width: 100vw;
  display: flex;
  position: relative;
`;

const NoSteps = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  font-size: 16px;
  color: ${({ theme }) => theme["@light"]};
`;

const EmptySteps = () => {
  const { t } = useTranslation();
  return (
    <Container>
      <NoSteps>{t("opportunity:wizardProcess.emptySteps")}</NoSteps>
    </Container>
  );
};

export default EmptySteps;
